function InializeIndustryCategories() {

    $('.first-level-industry input:checkbox').click(function (e) {
        var currentIndustryItem = $(this).closest('.industry-parent');
        if ($(this).is(':checked')) {
            currentIndustryItem.find('input:checkbox').prop('checked', true);
        } else {
            currentIndustryItem.find('input:checkbox').prop('checked', false);
        }
        UpdateSelectedItems();
    });

    $('.second-level-industry input:checkbox').click(function () {

        $(this).closest('.industry-child').find('input:checkbox').prop('checked', $(this).is(':checked'));

        var currentIndustryItem = $(this).closest('.industry-parent');
        var secondLevelIndustries = currentIndustryItem.find('.second-level-industry input:checkbox');
        var secondLevelSelected = currentIndustryItem.find('.second-level-industry input:checkbox:checked');

        if (secondLevelIndustries.length === secondLevelSelected.length) {
            currentIndustryItem.find('.first-level-industry input:checkbox').prop('checked', true);
        } else {
            currentIndustryItem.find('.first-level-industry input:checkbox').prop('checked', false);
        }
        UpdateSelectedItems();
    });

    $('.third-level-industry input:checkbox').click(function () {
        var thirdLevelIndustries = $(this).closest('.third-level-industry').find('input:checkbox');
        var thirdLevelSelected = $(this).closest('.third-level-industry').find('input:checkbox:checked');

        if (thirdLevelIndustries.length === thirdLevelSelected.length) {
            $(this).closest('.industry-child').find('.second-level-industry input:checkbox').prop('checked', true);
        } else {
            $(this).closest('.industry-child').find('.second-level-industry input:checkbox').prop('checked', false);
        }

        var currentIndustryItem = $(this).closest('.industry-parent');
        var secondLevelIndustries = currentIndustryItem.find('.second-level-industry input:checkbox');
        var secondLevelSelected = currentIndustryItem.find('.second-level-industry input:checkbox:checked');

        if (secondLevelIndustries.length === secondLevelSelected.length) {
            currentIndustryItem.find('.first-level-industry input:checkbox').prop('checked', true);
        } else {
            currentIndustryItem.find('.first-level-industry input:checkbox').prop('checked', false);
        }
        UpdateSelectedItems();
    });

    UpdateSelectedItems();
}

function UpdateSelectedItems() {
    $('#SelectedCategoryItems').val("");
    $('.industry-parent').each(function (index, item) {
        var firstIndustry = $(item).find('.first-level-industry input:checkbox:checked');
        if (firstIndustry.length > 0) {
            var firstIndustryId = firstIndustry.attr('id');
            var firstIndustrySelection = "~" + firstIndustryId + ":" + $("#Description" + firstIndustryId).val();
            $('#SelectedCategoryItems').val($('#SelectedCategoryItems').val() + firstIndustrySelection);
            return;
        }
        
        $(item).find('.second-level-industry input:checkbox').each(function (i, child) {
            if ($(child).is(':checked')) {
                var secondIndustryId = $(child).attr('id');
                var secondIndustrySelection = "~" + secondIndustryId + ":" + $("#Description" + secondIndustryId).val();
                $('#SelectedCategoryItems').val($('#SelectedCategoryItems').val() + secondIndustrySelection);
            } else {
                $(child).closest('.industry-child').find('.industry-grand-child input:checkbox:checked').each(function(j, grandChild) {
                    var thirdIndustryId = $(grandChild).attr('id');
                    var thirdIndustrySelection = "~" + thirdIndustryId + ":" + $("#Description" + thirdIndustryId).val();
                    $('#SelectedCategoryItems').val($('#SelectedCategoryItems').val() + thirdIndustrySelection);
                });
            }
        });
    });
}

function HideShowChildren(evt) {
    var key = evt.id;
    key = key.replace("img", "");

    if ($('#Header' + key + ' input:checkbox:first').is(":checked")) {
        $('#IndustryCategoryItemChildren' + key + ' input:checkbox').prop('checked', $('#Header' + key + " input:checkbox").prop('checked'));
    }

    if ($('#img' + key).attr('src') == '/Images/Common/plus_new.gif') {
        $('#img' + key).attr('src', '/Images/Common/minus_new.gif');
        $('#IndustryCategoryItemChildren' + key).show();

    }
    else {
        $('#img' + key).attr('src', '/Images/Common/plus_new.gif');
        $('#IndustryCategoryItemChildren' + key).hide();
    }
}

